import { useTranslation } from 'react-i18next';

import type { Contact } from '../../../../domain/contact';
import { NT_PURCHASE_PAGE_LINK } from '../../../../domain/gainAccessView';
import { useContactRevealTracking } from '../RevealContainer/useContactRevealTracking';

import { StyledButton, StyledIconButton } from './styles';

type Props = { contact?: Contact; variant?: 'single-reveal' | 'bulk-reveal' | 'bulk-export' };

export const UpgradeButton = ({ contact, variant = 'single-reveal' }: Props) => {
  const { t } = useTranslation();
  const { handleUpgradeToRevealClick } = useContactRevealTracking();

  if (variant === 'bulk-reveal' || variant === 'bulk-export') {
    return (
      <StyledIconButton variant="flatTrial" iconName="sparkles-gray" iconSize="12px">
        <a
          href={NT_PURCHASE_PAGE_LINK}
          target="_blank"
          rel="noreferrer"
          data-automation={variant === 'bulk-reveal' ? 'UpgradeToReveal' : 'UpgradeToExport'}
        >
          {t(variant === 'bulk-reveal' ? 'contact_card.reveal' : 'contact_card.export_crm')}
        </a>
      </StyledIconButton>
    );
  }

  return (
    <StyledButton
      onClick={() => handleUpgradeToRevealClick(contact as Contact)}
      variant="ghostTrial"
      data-automation="UpgradeToReveal"
    >
      <a href={NT_PURCHASE_PAGE_LINK} target="_blank" rel="noreferrer">
        {t('contact_card.upgrade_to_reveal')}
      </a>
    </StyledButton>
  );
};
